export default __webpack_public_path__ + "static/media/login-info-img.ca2230ad.png";